module.exports = __webpack_public_path__ + "img/loan-banner.a0ca33d7.png";